/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Wizard_Step3_Embed_On_Upload_DescriptionInputs */



/**
* | output |
* | --- |
* | "When files are uploaded into this space, they will be automatically embedded so they are immediately searchable and usable in AI chats." |
*
* @param {Spaces_Wizard_Step3_Embed_On_Upload_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_wizard_step3_embed_on_upload_description = /** @type {((inputs?: Spaces_Wizard_Step3_Embed_On_Upload_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Wizard_Step3_Embed_On_Upload_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn Dateien in diesen Space hochgeladen werden, werden sie automatisch embedden, damit sie sofort durchsuchbar sind und in AI-Chats verwendet werden können.")
	return /** @type {LocalizedString} */ ("When files are uploaded into this space, they will be automatically embedded so they are immediately searchable and usable in AI chats.")
});